import React from 'react';
import classNames from 'classnames';
import { Button as ReactAriaButton } from 'react-aria-components';

import styles from './Menu.module.scss';
import { Button } from 'components/core';
import { ButtonProps } from 'components/core/Button/Button.d';

export const MenuButton = ({ children, className, ...rest }: ButtonProps) => {
  return (
    <Button
      role="button"
      component={ReactAriaButton}
      className={classNames(styles.MenuButton, className)}
      aria-haspopup="dialog"
      {...rest}
    >
      {children}
    </Button>
  );
};
